<template>
  <div
    class="currency-switcher-sidebar"
  >
    <simple-list
      id="currency-list"
      ref="currencyList"
      :server-items="availableCurrencies"
      class="req"
      variant="currency-list"
      internal-scroll
      single-panel
      :height="listHeight"
      @item-update="getFocusableElements"
      @mounted="getFocusableElements"
    >
      <template #filter>
        <div
          ref="currencyListHeader"
          class="currency-switcher-header"
        >
          <header-close
            :deactivate="closeModal"
            :back="showBackBtn ? closeModal : null"
          />
          <div class="currency-switcher-search-bar form">
            <div class="currency-switcher-search-bar__input input">
              <input
                id="currencySearch"
                v-model="search"
                type="text"
                class="search-input icon-search"
                :class="[{ 'have-value': !!search }]"
                data-field-type="SingleLineText"
              >
              <label
                class="floating search-label"
                for="currencySearch"
              >
                {{ tc('booking.findYourCurrency') }}
              </label>
            </div>
          </div>
        </div>
      </template>
      <template #errors>
        <div
          v-if="rateErrorMsg"
          role="status"
          class="error-box"
        >
          <span>
            {{ rateErrorMsg }}
          </span>
        </div>
      </template>
      <template #rendered-list="{ items }">
        <ul>
          <li
            v-for="item in items"
            :key="item.IsoCode"
          >
            <currency-card
              :item="item"
              :search-input="search"
              :query-changed="queryChanged"
              :base-currency="baseCurrency"
              @selecting-currency="selectingCurrency = $event"
            />
          </li>
        </ul>
      </template>
    </simple-list>
  </div>
</template>

<script>
  import TabTrapMixin from '@mixins/tab-trap'
  import { mapGetters, mapState } from 'vuex'
  import HeaderClose from '../../booking-widget/components/header-close/header-close.vue'
  import CurrencyCard from './currency-card.vue'

  export default {
    name: 'CurrencySidebar',
    components: {
      HeaderClose,
      CurrencyCard
    },
    mixins: [TabTrapMixin],
    props: {
      showBackBtn: {
        type: Boolean,
        default: false
      },
      baseCurrency: {
        type: String
      }
    },
    data: () => ({
      listHeight: null,
      search: '',
      selectingCurrency: null,
      queryChanged: -1
    }),
    computed: {
      ...mapGetters('i18n', ['tc']),
      ...mapState('responsive', { wHeight: 'height' }),
      ...mapState('currency', ['currencies']),
      ...mapGetters('currency', ['currentCurrency', 'rateErrorMsg', 'orSelected']),
      availableCurrencies() {
        return this.currencies.filter((c) => c.IsoCode !== this.orSelected(this.baseCurrency || this.currentCurrency))
      }
    },
    watch: {
      search(val) {
        this.filterItems(val)
      }
    },
    methods: {
      closeModal() {
        this.$emit('close')
      },
      calculateListHeight() {
        const headerHeight = this.$refs.currencyListHeader.clientHeight
        this.listHeight = this.wHeight - headerHeight
      },
      async filterItems(value) {
        let filter = {}
        if (value) {
          filter = { $regex: `${value}`, $options: 'i' }
        } else {
          filter = { $exists: true }
        }
        const searchFilter = {
          $or: [
            { IsoCode: filter },
            { Name: filter },
          ]
        }
        await this.$refs.currencyList.updateFilter(searchFilter)
        this.queryChanged++
        this.getFocusableElements()
      },
    }
  }
</script>
